var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{opacity:0.2;fill:none;stroke:#000000;stroke-width:5.000000e-02;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "grid_system"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4,4.4c0,0-0.1-0.1-0.1-0.1c-0.8-0.8-2-1.3-3.1-1.3H8.8C7.7,3,6.6,3.5,5.7,4.3c0,0-0.1,0.1-0.1,0.1L3.9,6.8   C3.3,7.7,3,8.7,3,9.7V17c0,2.2,1.8,4,4,4h10c2.2,0,4-1.8,4-4V9.7c0-1-0.3-2-0.9-2.9L18.4,4.4z M5.5,8l1.6-2.3C7.6,5.2,8.2,5,8.8,5   h6.3c0.6,0,1.2,0.2,1.7,0.7L18.5,8c0,0,0,0,0,0h-4.2H9.7L5.5,8C5.5,8,5.5,8,5.5,8z M13.3,10v2.5l-0.9-0.4C12.3,12,12.1,12,12,12   s-0.3,0-0.4,0.1l-0.9,0.4V10H13.3z M19,17c0,1.1-0.9,2-2,2H7c-1.1,0-2-0.9-2-2v-7h3.7v4c0,0.3,0.2,0.7,0.5,0.8   c0.3,0.2,0.6,0.2,0.9,0.1l1.9-0.8l1.9,0.8C14,15,14.2,15,14.3,15c0.2,0,0.4-0.1,0.5-0.2c0.3-0.2,0.5-0.5,0.5-0.8v-4H19V17z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.9fee43ae4274ceba9c14c55e08a5a8c7.svg";
export { ForwardRef as ReactComponent };